<p-card *ngIf="task" [style]="{ 'margin-bottom': '1em' }">
    <ng-template pTemplate="title">
        <div class="flex justify-content-between align-items-center">
            <span class="p-card-title">{{ task.title }}</span>
            <p-tag [value]="task.priority" [severity]="getPrioritySeverity(task.priority)" [rounded]="true"></p-tag>
        </div>
    </ng-template>
    <!-- <ng-template pTemplate="subtitle">
        Due: {{ task.dueDate | appDate:'medium' }}
    </ng-template> -->
    <ng-template pTemplate="content">
        <p class="m-0">{{ task.description }}</p>
        <div class="flex justify-content-between mt-3">
            <div class="flex align-items-center">
                <span class="font-bold mr-2">Assigned To:</span>
                <div *ngIf="task.assignedTo" class="flex align-items-center">
                    <p-avatar [image]="task.assignedTo.profilePictureUrl || 'assets/manager.png'" shape="circle" class="mr-2"></p-avatar>
                    <span>{{ task.assignedTo.fullName }}</span>
                </div>
                <span *ngIf="!task.assignedTo">Unassigned</span>
            </div>
            <div class="flex align-items-center">
                <span class="font-bold mr-2">Requested By:</span>
                <div *ngIf="task.requestedBy" class="flex align-items-center">
                    <p-avatar [image]="task.requestedBy.profilePictureUrl || 'assets/manager.png'" shape="circle" class="mr-2"></p-avatar>
                    <span>{{ task.requestedBy.fullName }}</span>
                </div>
            </div>
        </div>
    </ng-template>
    <ng-template pTemplate="footer">
        <div class="flex gap-2">
            <p-button label="View" icon="pi pi-eye" (click)="onViewTask()" [disabled]="!task.routerLink" pTooltip="View Details"></p-button>
            <p-button label="Mark as Done" icon="pi pi-check" (click)="onCompleteTask()" styleClass="p-button-success" *ngIf="task.isPending"></p-button>
        </div>
    </ng-template>
</p-card>
